// JS 调 APP 方法console.log('公共版=>个性化');
const toIndividuation = function(callback = '', setting = {}){
  if(window.Android){
    window.Android.toIndividuation(callback, setting);
  }
}
const changeScanState = function(state){
  if(window.Android){
    window.Android.changeScanState(state);
  }
}
const hideKeyboard = function(){
  if(window.Android){
    window.Android.hideKeyboard();
  }
}
const changeWebViewByURL = function(URL){
  if(window.Android){
    window.Android.changeWebViewByURL(URL);
  }
}
// let initPageByCodeVM = null;
// APP 调 JS 方法
// const initPageByCode = function(code, vm = null){
//   initPageByCodeVM = vm;
//   console.log('解析出码后将码传给前端' + initPageByCodeVM);
// }

window.toIndividuation = toIndividuation;
window.changeScanState = changeScanState;
// window.initPageByCode = initPageByCode;
const androidpc = {
  install (Vue) {
    Vue.prototype.$toIndividuation = toIndividuation;
    Vue.prototype.$changeScanState = changeScanState;
    Vue.prototype.$hideKeyboard = hideKeyboard;
    Vue.prototype.$changeWebViewByURL = changeWebViewByURL;
    // Vue.prototype.$initPageByCode = initPageByCode;

    Vue.toIndividuation = toIndividuation;
    Vue.changeScanState = changeScanState;
    Vue.hideKeyboard = hideKeyboard;
    Vue.changeWebViewByURL = changeWebViewByURL;
  }
}
export default androidpc



// WEBPACK FOOTER //
// ./src/utils/androidCallback.js